import type { CategoryDto, CategoryModel } from '../../data-layer/categories/types';

export const toCategoryModel = (category: CategoryDto): CategoryModel => ({
    id: category.id.toString(),
    displayName: category.display_name,
});
